$(document).ready(function () {
  var waitForEl = function (selector, callback) {
    if (jQuery(selector).length) {
      callback();
    } else {
      setTimeout(function () {
        waitForEl(selector, callback);
      }, 300);
    }
  };

  waitForEl(".product-card-wrapper .card--media button.product--button-wishlist", function () {
    setTimeout(function () {
      $(".product-card-wrapper .card--media button.product--button-wishlist").each(function (index, element) {
        if ($(element).hasClass("swym-added")) {
          $(element).closest(".product-detail").addClass("swym-added");
          $(element).closest(".product-card-wrapper").addClass("swym-added");
        }
      });
    }, 900);
  });

  $(".product-card-wrapper .card--media button.product--button-wishlist").click(function () {
    if ($(this).hasClass("swym-added")) {
      $(this).closest(".product-card-wrapper").removeClass("swym-added");
      $(this).removeClass("swym-added");
    } else {
      $(this).closest(".product-card-wrapper").addClass("swym-added");
      $(this).addClass("swym-added");
    }
    setTimeout(function () {
      $(".product-card-wrapper .card--media button").each(function (index, element) {
        if (!$(element).closest(".product-card-wrapper").hasClass("swym-added")) {
          $(element).removeClass("swym-added");
        }
      });
    }, 300);
  });

  $(".product__info-wrapper button.product--button-wishlist").click(function () {
    if ($(this).hasClass("swym-added")) {
      $(this).removeClass("swym-added");
    } else {
      $(this).addClass("swym-added");
    }
    setTimeout(function () {
      $(".product-card-wrapper .card--media button").each(function (index, element) {
        if (!$('.product__info-wrapper').closest(".product-card-wrapper").hasClass("swym-added")) {
          $(element).removeClass("swym-added");
        }else {
          $(element).addClass("swym-added");
        }
      });
    }, 1000);
  });

  // $(".product-card-wrapper .swym-add-to-wishlist-view-product").click(
  //   function () {
  //     if ($(this).hasClass("swym-added")) {
  //       $(this).closest(".product--detail-wishlist").removeClass("swym-added");
  //     } else {
  //       $(this).closest(".product--detail-wishlist").addClass("swym-added");
  //     }
  //     setTimeout(function () {
  //       $(".product-card-wrapper .swym-add-to-wishlist-view-product").each(
  //         function (index, element) {
  //           if (
  //             !$(element)
  //               .closest(".product--detail-wishlist")
  //               .hasClass("swym-added")
  //           ) {
  //             $(element).removeClass("swym-added");
  //           }
  //         }
  //       );
  //     }, 1000);
  //   }
  // );

  // Header wishlist
  $(".wishlist-box .swym-wishlist").click(function (event) {
    event.stopPropagation();
    $("header .menulink details").removeAttr("open");
    $("body").removeClass("open-cart");
    $(this).parent("li").siblings("li").removeClass("active");
    $(this).parent("li").toggleClass("active");
    if ($(this).parent("li").hasClass("active")) {
      $(".main-header").addClass("main-header-active");
    } else {
      $(".main-header").removeClass("main-header-active");
    }
  });
});

jQuery(window).on('load', function() {
  var waitForEl = function (selector, callback) {
    if (jQuery(selector).length) {
      callback();
    } else {
      setTimeout(function () {
        waitForEl(selector, callback);
      }, 300);
    }
  };
  
  waitForEl(".product-card-wrapper .card--media button.product--button-wishlist", function () {
    setTimeout(function () {
      jQuery(".product-card-wrapper .card--media button.product--button-wishlist").each(function (index, element) {
        if (jQuery(element).hasClass("swym-added")) {
          jQuery(element).closest(".product-detail").addClass("swym-added");
          jQuery(element).closest(".product-card-wrapper").addClass("swym-added");
        }
      });
    }, 900);
  });

  waitForEl(".listing-page .wishlist", function () {
    setTimeout(function () {
      $(".listing-page .wishlist button").each(function (index, element) {
        if ($(element).hasClass("swym-added")) {
          $(element)
            .closest(".product--detail-wishlist")
            .addClass("swym-added");
        }
      });
    }, 1000);
  });
})
